import styled from 'styled-components';
import { Upload } from 'antd';

export const HeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const HeaderImagePreview = styled.div`
  position: relative;
  width: 50px;
  height: 50px;
`;

export const HeaderImagePreviewContainer = styled.div`
  border: 1px solid #ddd;
  width: 50px;
  height: 50px;
  margin-right: 10px;
`;

export const UploadStyled = styled(Upload)`
  text-align: center;

  .ant-upload-list {
    display: none;
  }
`;

export const ImageUploadContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
